// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"620":"597b3ca7","764":"64b77968","860":"7011121f"}[chunkId] + ".chunk.js";
};